import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Space,
  DatePicker,
  Select,
  Alert,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  MinusCircleOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
const { Text } = Typography;

const options_status = [
  { value: 0, label: "Ag. Avaliação" },
  { value: 1, label: "Ideia Aceita (Aguardando Mais Informações)" },
  { value: 2, label: "Ideia com oportunidade" },
  { value: 3, label: "Retorno de Informações" },
  { value: 4, label: "Em desenvolvimento" },
  { value: 5, label: "Finalizado" },
];

export const SugestoesCadSorteios = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarSorteios();
  }, []);

  // LISTAR
  const listarSorteios = async () => {
    setLoading(true);
    const api = await http("get", `v1/sugestoes_sorteios/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarSorteio = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/sugestoes_sorteios/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarSorteios();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarSorteio = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/sugestoes_sorteios/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarSorteios();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descricao",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Data Inicial",
      dataIndex: "data_inicio",
      render: (_, e) => dayjs(e.data_inicio).format("DD/MM/YYYY"),
      sorter: (a, b) => dayjs(a.data_inicio).format("DD/MM/YYYY")?.localeCompare(b.data_inicio.format("DD/MM/YYYY")),
    },
    {
      title: "Data Final",
      dataIndex: "data_fim",
      render: (_, e) => dayjs(e.data_fim).format("DD/MM/YYYY"),
      sorter: (a, b) => dayjs(a.data_fim).format("DD/MM/YYYY")?.localeCompare(dayjs(b.data_fim).format("DD/MM/YYYY")),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? "Finalizado" : "Aguardando"),
      sorter: (a, b) =>
        (a.status === 1 ? "Finalizado" : "Aguardando")?.localeCompare(b.status === 1 ? "Finalizado" : "Aguardando"),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Abrir">
            <Button
              loading={loading}
              onClick={() => navigate(`/sugestoes/sorteios/itens/${e.id}`)}
              icon={<OrderedListOutlined />}
            />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarSorteio(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    var filtered = formulario.itens.filter(function (x) {
      return x !== undefined;
    });

    if (filtered.length === 0) {
      message.error("Nenhum item informado!");
      return;
    }

    if (formulario.data_inicio > formulario.data_fim) {
      message.error("Periodo inválido!");
      return;
    }

    formulario.data_inicio = dayjs(formulario.data_inicio).format("YYYY-MM-DD");
    formulario.data_fim = dayjs(formulario.data_fim).format("YYYY-MM-DD");
    cadastrarSorteio(formulario);
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.data_inicio?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.data_fim?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> Novo Sorteio
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="data_inicio"
                label="Data início"
                rules={[{ required: true, message: "Informe a data inicial!" }]}>
                <DatePicker size="large" style={{ width: "100%" }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="data_fim"
                label="Data fim"
                rules={[{ required: true, message: "Informe a data final!" }]}>
                <DatePicker size="large" style={{ width: "100%" }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="status_participantes"
                label="Status participantes"
                rules={[{ required: true, message: "Selcione os status!" }]}>
                <Select
                  mode="multiple"
                  allowClear
                  size="large"
                  style={{ width: "100%" }}
                  placeholder="Selcione os status"
                  options={options_status}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={24}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Text>Itens do Sorteio</Text>
                <Form.List name="itens" initialValue={[[], []]}>
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field) => (
                        <Form.Item required={false} key={field.key}>
                          <Input.Group compact>
                            <Form.Item {...field} noStyle>
                              <Input
                                placeholder="Informe a descrição!"
                                disabled={loading}
                                style={{ width: "calc(100% - 40px)" }}
                              />
                            </Form.Item>
                            {fields.length > 0 ? (
                              <Button
                                icon={<MinusCircleOutlined />}
                                onClick={() => {
                                  remove(field.name);
                                }}
                              />
                            ) : null}
                          </Input.Group>
                        </Form.Item>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
                          Adicioanar campo
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Space>
            </Col>

            <Col className="gutter-row" span={24}>
              <Alert
                message="Observações"
                description="Ideias já sorteadas não participam de novos sorteios."
                type="info"
                showIcon
              />
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Inova" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Sugestões Sorteios"
              subtitle="Gestão de sorteios"
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
